import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { MunicipalityService } from '../../services/municipality.service';
import { SharedService } from '../../services/shared.service';

interface DataItem {
  name: string;
  flag: string;
  clientId: number;
  code: string;
  disabled: boolean;
}

@Component({
  selector: 'app-select-municipality-dialog',
  templateUrl: './select-municipality-dialog.component.html',
  styleUrls: ['./select-municipality-dialog.component.scss']
})
export class SelectMunicipalityDialogComponent implements OnInit {
  // public municip: any = [];
  public selected: any = [];
  public searchForm: FormGroup;
  public filterValue = '';
  private prevUrl = '';
  municip = environment.municip;
  filtered = [];

  constructor(
    private _dialogRef: MatDialogRef<SelectMunicipalityDialogComponent>,
    private _fb: FormBuilder,
    private _router: Router,
    private sharedService: SharedService,
    private _municipalityService: MunicipalityService
  ) {
    this.filterData('');
    this.searchForm = this._fb.group({
      search: this._fb.control('')
    });
    this.createSearchForm();
    this.makeArrayCopy();
  }

  ngOnInit(): void {
    this.sharedService.previousUrl.subscribe((data) => {
      this.prevUrl = data;
    });
  }

  private filterData(value: string): void {
    const filtered = [];

    for (const record of this.municip) {
      const [letter, data] = record as [string, DataItem[]];
      const row = [];
      for (const obj of data) {
        if (obj.name.includes(value)) {
          row.push(obj);
        }
      }
      if (row.length) {
        filtered.push([letter, row]);
      }
    }

    this.filtered = filtered;
  }

  onChange(e: Event): void {
    this.filterData((<HTMLInputElement>e.target).value);
  }

  clearSearchTerm(searchTerm: HTMLInputElement): void {
    this.filterData('');
    searchTerm.value = '';
  }

  makeArrayCopy(): void {
    this.selected = JSON.parse(JSON.stringify(this.municip));
  }

  createSearchForm(): void {
    this.searchForm
      .get('search')
      .valueChanges.pipe(debounceTime(500))
      .subscribe((value: any) => {
        this.filterData(value);
        // this.applyFilter(value);
      });
  }
  chooseMunicipality(municip: any): void {
    if (municip.disabled) {
      return;
    }
    sessionStorage.setItem('clientId', municip.clientId);
    if (this.prevUrl.indexOf('/select-municipality') == -1) {
      this._router.navigateByUrl(this.prevUrl);
    } else {
      this._router.navigate(['/home']);
    }
    this._dialogRef.close();
    this._municipalityService.changeClient(Number(municip.clientId), true);
  }

  applyFilter(filterValue: string): void {
    this.makeArrayCopy();
    let e;
    if (filterValue !== '') {
      this.selected.forEach((element: any) => {
        e = element[1];
        for (let i = 0; i < e.length; i++) {
          if (
            e[i].name.indexOf(filterValue) !== 0 &&
            e[i].name[e[i].name.indexOf(filterValue) - 1] !== ' '
          ) {
            element[1].splice(i, 1);
            i--;
          }
        }
      });
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i][1].length === 0) {
          this.selected.splice(i, 1);
          i--;
        }
      }
    }
  }
  searchItem() {}
  clearFilter() {
    this.searchForm.get('search').setValue('');
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/select-municipality/select-municipality-dialog/select-municipality-dialog.component.ts